import SecuritySettingsCard from '../profile/SecuritySettingsCard'
import { SessionList } from '../profile/SessionList'
import HubPlatformCard from './HubPlatformCard'
import PasskeysCard from './PasskeysCard'
import SecondFactorCard from './SecondFactorCard'

/**
 * VH-285 — everything about the login in one place, as FinanceHub's
 * /security: the password, the authenticator with its recovery codes and the
 * last logins, the passkeys (VH-296), the HubPlatform link (VH-317) and the
 * open sessions (VH-284).
 */
export default function SecurityPanel() {
  return (
    <div className="space-y-6">
      <SecuritySettingsCard />
      <SecondFactorCard />
      <PasskeysCard />
      <HubPlatformCard />
      <div className="card">
        <div className="card-body">
          <SessionList />
        </div>
      </div>
    </div>
  )
}
